module.exports = __webpack_public_path__ + "img/3.707d7028.png";